import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { TechnicianStateModel } from './technician.model'
import { TechnicianService } from '../technician.service'
import {
  GetTechnicianList,
  GetLaborSummary,
  GetTechnicianSummary,
  GetServiceAdvisorSummary,
  GetServiceAdvisorList,
  AdminGetEfficiencyTargets,
  AdminUpdateEfficiencyTargets
} from './technician.actions'
import {
  ILaborSummaryResponse,
  ITechnicianSummaryResponse
} from '../../interfaces/technician-summary.interface'
import { IServiceAdvisorSummaryResponse } from '../../interfaces/service-advisor-summary.interface'

@State<TechnicianStateModel>({
  name: 'technician'
})
@Injectable()
export class TechnicianState {
  constructor(private technicianService: TechnicianService) {}

  @Selector()
  static laborSummaryResponse(state: TechnicianStateModel): ILaborSummaryResponse | undefined {
    return state.laborSummaryResponse
  }

  @Selector()
  static summaryResponse(state: TechnicianStateModel): ITechnicianSummaryResponse | undefined {
    return state.summaryResponse
  }

  @Selector()
  static listResponse(state: TechnicianStateModel) {
    return state.listResponse
  }

  @Selector()
  static serviceAdvisorSummaryResponse(
    state: TechnicianStateModel
  ): IServiceAdvisorSummaryResponse | undefined {
    return state.serviceAdvisorSummaryResponse
  }

  @Selector()
  static serviceAdvisorListResponse(state: TechnicianStateModel) {
    return state.serviceAdvisorListResponse
  }

  @Selector()
  static efficiencyTargets(state: TechnicianStateModel) {
    return state.efficiencyTargets
  }

  @Action(GetLaborSummary)
  getLaborSummary(ctx: StateContext<TechnicianStateModel>, { payload }: GetLaborSummary) {
    ctx.patchState({
      laborSummaryResponse: undefined
    })
    return this.technicianService.getLaborSummary(payload).pipe(
      tap((res) => {
        ctx.patchState({
          laborSummaryResponse: res
        })
      })
    )
  }

  @Action(GetTechnicianSummary)
  getTechnicianSummary(ctx: StateContext<TechnicianStateModel>, { payload }: GetTechnicianSummary) {
    ctx.patchState({
      summaryResponse: undefined
    })
    return this.technicianService.getTechnicianSummary(payload).pipe(
      tap((res) => {
        ctx.patchState({
          summaryResponse: res
        })
      })
    )
  }

  @Action(GetTechnicianList)
  getTechnicianList(ctx: StateContext<TechnicianStateModel>, { info }: GetTechnicianList) {
    ctx.patchState({
      listResponse: undefined
    })
    return this.technicianService.getTechnicianList(info).pipe(
      tap((res) => {
        ctx.patchState({
          listResponse: res
        })
      })
    )
  }

  @Action(GetServiceAdvisorSummary)
  getServiceAdvisorSummary(
    ctx: StateContext<TechnicianStateModel>,
    { payload }: GetServiceAdvisorSummary
  ) {
    ctx.patchState({
      serviceAdvisorSummaryResponse: undefined
    })
    return this.technicianService.getServiceAdvisorSummary(payload).pipe(
      tap((res) => {
        ctx.patchState({
          serviceAdvisorSummaryResponse: res
        })
      })
    )
  }

  @Action(GetServiceAdvisorList)
  getServiceAdvisorList(ctx: StateContext<TechnicianStateModel>, { info }: GetServiceAdvisorList) {
    ctx.patchState({
      serviceAdvisorListResponse: undefined
    })
    return this.technicianService.getServiceAdvisorList(info).pipe(
      tap((res) => {
        ctx.patchState({
          serviceAdvisorListResponse: res
        })
      })
    )
  }

  @Action(AdminGetEfficiencyTargets)
  adminGetEfficiencyTargets(ctx: StateContext<TechnicianStateModel>) {
    return this.technicianService.adminGetEfficiencyTargets().pipe(
      tap((res) => {
        ctx.patchState({
          efficiencyTargets: res?.items ?? []
        })
      })
    )
  }

  @Action(AdminUpdateEfficiencyTargets)
  adminUpdateEfficiencyTargets(
    ctx: StateContext<TechnicianStateModel>,
    { payload }: AdminUpdateEfficiencyTargets
  ) {
    return this.technicianService.adminUpdateEfficiencyTargets(payload).pipe(
      tap((res) => {
        ctx.patchState({
          efficiencyTargets: res?.items ?? []
        })
      })
    )
  }
}
